
import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class TablaDetallePorCerealLinea12Service {
  static async getDataTablaDetallePorCerealLinea12 () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_cereal_sector12')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 1-2.')
      return (data)
    })
  }

  static async getDataTablaDetallePorCerealLinea12Total () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_cereal_sector12_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 1-2.')
      return (data)
    })
  }
}
